import React, { useState } from "react";
import { PinInput } from "react-input-pin-code";

import {
  Box,
  Paper,
  Grid,
  Typography,
  useTheme,
  Button,
  Stack,
  Divider,
  TextField,
  formControlClasses,
  outlinedInputClasses,
  FormLabel,
  InputAdornment,
  Modal,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import FormModal from "../../components/FormModal";
import {
  useDecodedToken,
  resetToken,
} from "../../Services/Routes/App/PrivateRouts";
import { refreshLayout } from "../../Services/Functions/global";
import { Password } from "@mui/icons-material";
import { headersPost } from "../../Services/API";
import { ApiUrls } from "../../Services/Routes/API";
import { MainRoutes } from "../../Services/Routes/App";
import { Formik, Form } from "formik";
import { makeStyles } from "@mui/styles";
import { LimospayTextIcon } from "../../Svg";
import { phoneNumberValidation } from "../../Services/validation/modalValidation";
import { set } from "date-fns";
import LoadCard from "../../components/LoadCard";
import SuccessCard from "../../components/SuccessCard";

const useStyles = makeStyles({
  flexSetting: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
});
const Profile = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const user = useDecodedToken();
  const classes = useStyles();

  const [nameModal, setNameModal] = useState(false);
  const [emailModal, setEmailModal] = useState(false);
  const [passwordModal, setPasswordModal] = useState(false);
  const [phoneNumberModal, setPhoneNumberModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [modalNumber, setModalNumber] = useState(1);
  const [otpValue, setOtpValue] = useState(["", "", "", "", "", ""]);
  const [emailUpdateModal, setEmailUpdateModal] = useState(false);
  const [emailForOtp, setEmailForOtp] = useState("");
  const [successModal, setSuccessModal] = useState(false);

  const modalCloseforAll = () => {
    setNameModal(false);
    setEmailUpdateModal(false);
    setEmailModal(false);
    setPasswordModal(false);
    setPhoneNumberModal(false);
    setSuccessModal(false);
  };

  const Name_Update_Array = [
    { formKey: "user", name: "first_name", label: "First Name" },
    { formKey: "user", name: "last_name", label: "Last Name" },
  ];

  const Email_Update_Array = [
    { formKey: "user", name: "email", label: "Enter New Email" },
  ];

  const Password_Update_Array = [
    {
      formKey: "user",
      name: "old_password",
      type: "password",
      label: "Enter Old Password",
    },
    {
      formKey: "user",
      name: "password",
      label: "Enter New Password",
      type: "password",
    },
    {
      formKey: "user",
      name: "con_password",
      label: "Confirm Password",
      type: "password",
    },
  ];
  const PhoneNumber_Update_Array = [
    {
      formKey: "user",
      name: "phone_number",
      label: "Enter New Number",
      type: "text",
    },
  ];
  const Form_Modal_Buttons = [
    {
      text: "Back",
      name: "back",
      width: 90,
      bgcolor: theme?.palette?.primary?.dark,
    },
    {
      text: "Confirm",
      name: "next",
      type: "submit",
      width: 150,
    },
  ];

  const handleClosee = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  // initial Values for Email Update

  const initialValues = {
    email: "",
    otp_code: "",
  };

  // Name and Phone Update

  const updateUserHandler = (data) => {
    setOpen(true);
    headersPost(ApiUrls?.UPDATE_USER, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          const NEW_TOKEN = res?.data?.new_token;
          if (NEW_TOKEN) {
            resetToken(NEW_TOKEN);
            // refreshLayout();
          }
          setNameModal(false);
          setPhoneNumberModal(false);
          setSuccessModal(true);
          // setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          // setAlertIcon("success");
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };
  //  Password update

  const updateUserPasswordHandler = (data) => {
    setOpen(true);
    headersPost(ApiUrls?.UPDATE_PASSWORD, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          // setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          // setAlertIcon("success");
          setPasswordModal(false);
          setSuccessModal(true);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };
  // GET OTP
  const emailVerificationHandler = (values) => {
    const data = {
      user: {
        email: values || emailForOtp,
      },
    };

    headersPost(ApiUrls?.UPDATE_USER, data)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
        }
      })
      .catch((err) => {
        const { response } = err;

        setAlertMsg(response?.data?.message);

        setAlertIcon("warning");
      });
  };

  // VErify OTP for otp
  const verifyOtpHandler = (values) => {
    const data = {
      user: {
        type: "otp",
        email: values?.email,
        otp_code: otpValue,
      },
    };
    setOpen(true);
    headersPost(ApiUrls?.VERIFY_OTP_FOR_EMAIL_UPDATE, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          // setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          // setAlertIcon("success");
          setOtpValue(["", "", "", "", "", ""]);
          setEmailModal(false);
          setEmailUpdateModal(true);
          // setSuccessModal(true);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };
  // update email with otp

  const emailUpdateHandler = (data) => {
    setOpen(true);
    headersPost(ApiUrls?.VERIFY_OTP_FOR_EMAIL_UPDATE, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          const NEW_TOKEN = res?.data?.new_token;
          if (NEW_TOKEN) {
            resetToken(NEW_TOKEN);
          }
          setEmailUpdateModal(false);
          setSuccessModal(true);
          // setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          // setAlertIcon("success");
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };
  return (
    <Box mt={7}>
      <Paper sx={{ borderRadius: 1, minHeight: "100vh" }}>
        <Grid p={5} container>
          <Grid item md={3}>
            <Box
              bgcolor={theme.palette.grey.A100}
              borderRadius={"50%"}
              height={140}
              width={140}
            ></Box>
          </Grid>
          <Grid
            md={3}
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}
          >
            <Box>
              <Typography variant="h6">Profile Picture</Typography>
              <Typography variant="body2" color={theme.palette.grey.A700}>
                {" "}
                This will be displayed on your profile.{" "}
              </Typography>
            </Box>
          </Grid>
          <Grid item md={6} display="flex" justifyContent={"flex-end"}>
            <Box
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
            >
              <Stack spacing={2} direction="row">
                <Button
                  size="large"
                  variant="contained"
                  sx={{ maxHeight: "50px" }}
                >
                  Upload New
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  sx={{ bgcolor: theme.palette.grey.A100, maxHeight: "50px" }}
                >
                  Remove Picture
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
        <Box paddingY={1} display={"flex"} justifyContent={"flex-start"}>
          <Divider sx={{ marginLeft: "5%" }} width={"65%"} />
        </Box>
        <Grid container paddingY={3}>
          <Grid item xs={12} sm={6} paddingX={"5%"} mt={1}>
            <FormLabel sx={{ fontSize: "19px" }}> Name </FormLabel>
            <TextField
              disabled
              value={user.name}
              sx={{
                [`&.${formControlClasses?.root}`]: {
                  border: "none",
                },
                [`& .${outlinedInputClasses?.root}`]: {
                  backgroundColor: `${theme.palette.info.main}`,
                  border: "none",
                },
                mt: 1,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      onClick={() => {
                        setNameModal(true);
                      }}
                      sx={{
                        padding: theme.spacing(0),
                        height: "31px",
                        minWidth: "31px",
                        borderRadius: 6,
                      }}
                    >
                      Edit
                    </Button>
                  </InputAdornment>
                ),
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6} paddingX={"5%"} mt={1}>
            <FormLabel sx={{ fontSize: "19px" }}> Email </FormLabel>
            <TextField
              disabled
              value={user.email}
              sx={{
                [`&.${formControlClasses?.root}`]: {
                  border: "none",
                },
                [`& .${outlinedInputClasses?.root}`]: {
                  backgroundColor: `${theme.palette.info.main}`,
                  border: "none",
                },
                mt: 1,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      onClick={() => {
                        setEmailModal(true);
                      }}
                      sx={{
                        padding: theme.spacing(0),
                        height: "31px",
                        minWidth: "31px",
                        borderRadius: 6,
                      }}
                    >
                      Edit
                    </Button>
                  </InputAdornment>
                ),
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6} paddingX={"5%"} mt={1}>
            <FormLabel sx={{ fontSize: "19px" }}> Password </FormLabel>
            <TextField
              value={"******"}
              type="password"
              disabled
              sx={{
                [`&.${formControlClasses?.root}`]: {
                  border: "none",
                },
                [`& .${outlinedInputClasses?.root}`]: {
                  backgroundColor: `${theme.palette.info.main}`,
                  border: "none",
                },
                mt: 1,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      onClick={() => {
                        setPasswordModal(true);
                      }}
                      sx={{
                        padding: theme.spacing(0),
                        height: "31px",
                        minWidth: "31px",
                        borderRadius: 6,
                      }}
                    >
                      Change
                    </Button>
                  </InputAdornment>
                ),
              }}
              fullWidth
            >
              {" "}
              ******
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} paddingX={"5%"} mt={1}>
            <FormLabel sx={{ fontSize: "19px" }}> Phone # </FormLabel>
            <TextField
              disabled
              value={user.phone_number || "Not Available"}
              sx={{
                [`&.${formControlClasses?.root}`]: {
                  border: "none",
                },
                [`& .${outlinedInputClasses?.root}`]: {
                  backgroundColor: `${theme.palette.info.main}`,
                  border: "none",
                },
                mt: 1,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      onClick={() => {
                        setPhoneNumberModal(true);
                      }}
                      sx={{
                        padding: theme.spacing(0),
                        height: "31px",
                        minWidth: "31px",
                        borderRadius: 6,
                      }}
                    >
                      change
                    </Button>
                  </InputAdornment>
                ),
              }}
              fullWidth
            ></TextField>
          </Grid>
        </Grid>
      </Paper>
      <FormModal
        open={nameModal}
        onClose={modalCloseforAll}
        MainHeading={"Edit User Name"}
        SubHeading={""}
        SimpleText={""}
        TextFieldArray={Name_Update_Array}
        ButtonsArray={Form_Modal_Buttons}
        onSubmit={updateUserHandler}
      />
      <FormModal
        open={emailUpdateModal}
        onClose={modalCloseforAll}
        MainHeading={"Edit E-mail"}
        SubHeading={""}
        SimpleText={""}
        TextFieldArray={Email_Update_Array}
        ButtonsArray={Form_Modal_Buttons}
        initialFormData={{
          user: {
            type: "email",
          },
        }}
        onSubmit={emailUpdateHandler}
      />
      <Modal
        open={emailModal}
        onClose={modalCloseforAll}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            width: { xs: "80%", md: "50%", lg: "30%" },
            padding: 1,
            minHeight: "85vh",
            borderRadius: 1,
            borderTop: `5px solid  ${theme.palette.primary.main}`,
          }}
        >
          <Formik
            initialValues={initialValues}
            onSubmit={verifyOtpHandler}
            isValidating={true}
            isSubmitting={true}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleSubmit,
              setFieldTouched,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Box className={classes.flexSetting} mt={1}>
                  <LimospayTextIcon />
                </Box>

                <Box margin={"auto"} width={"80%"}>
                  <TextField
                    fullWidth
                    name="email"
                    type={"email"}
                    variant="standard"
                    label="Enter your current email"
                    value={values?.email}
                    // error={touched?.amount && Boolean(errors?.amount)}
                    // helperText={touched?.amount && errors?.amount}
                    onChange={(e) => {
                      const cValue = e.target.value;
                      if (cValue.includes(".") && cValue.includes("@")) {
                        emailVerificationHandler(e.target.value);
                        setEmailForOtp(e.target.value);
                        console.log(emailForOtp);
                      }
                      handleChange(e);
                    }}
                  ></TextField>
                  <Box
                    display={"flex"}
                    justifyContent={"flex-end"}
                    marginTop={1}
                  >
                    {" "}
                    <Typography
                      // component={"button"}
                      // variant="caption"
                      onClick={() => {
                        emailVerificationHandler();
                      }}
                      sx={{
                        border: "none",
                        backgroundColor: "white",
                        cursor: "pointer",
                      }}
                      color={"#979898"}
                    >
                      Resend OTP?
                    </Typography>{" "}
                  </Box>
                  <Box
                    sx={{
                      marginTop: 1,
                      paddingY: 2,
                    }}
                  >
                    <PinInput
                      values={otpValue}
                      length={6}
                      onChange={(otp, index, values) => {
                        setOtpValue(values);
                      }}
                      validate={/^[0-9]*$/}
                      size="lg"
                      placeholder=""
                      containerStyle={{
                        display: "grid",
                        gridAutoColumns: "max-content",
                        gridAutoFlow: "column",
                        justifyContent: "center",
                        margin: "1rem 0",
                      }}
                      inputStyle={{
                        backgroundColor: "rgb(248, 249, 250)",
                        borderRadius: "0.3rem",
                        fontSize: "1.2rem",
                        margin: " 0.2rem",
                        height: "3rem",
                        outline: "none",
                        textAlign: "center",
                        transitionDuration: "250ms",
                        transitionProperty:
                          "background, color, border, box-shadow, transform",
                        width: "3rem",
                      }}
                    />
                  </Box>
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"space-around"}
                  >
                    <Button
                      onClick={() => modalCloseforAll()}
                      variant="contained"
                      sx={{
                        marginTop: 1,
                        height: theme.spacing(5),
                        width: theme.spacing(12),
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      type="submit"
                      sx={{
                        marginTop: 1,
                        height: theme.spacing(5),
                        width: theme.spacing(16),
                      }}
                    >
                      {" "}
                      Confirm{" "}
                    </Button>
                  </Box>
                </Box>
              </Form>
            )}
          </Formik>
        </Paper>
      </Modal>
      <FormModal
        open={passwordModal}
        onClose={modalCloseforAll}
        MainHeading={"Change Password"}
        SubHeading={""}
        SimpleText={""}
        TextFieldArray={Password_Update_Array}
        ButtonsArray={Form_Modal_Buttons}
        onSubmit={updateUserPasswordHandler}
      />
      <FormModal
        open={phoneNumberModal}
        onClose={modalCloseforAll}
        MainHeading={"Change Phone Number"}
        SubHeading={""}
        SimpleText={""}
        TextFieldArray={PhoneNumber_Update_Array}
        ButtonsArray={Form_Modal_Buttons}
        onSubmit={updateUserHandler}
        ValidationSchemaModals={phoneNumberValidation}
      />
      <LoadCard open={open} tittle={"Please Wait..."} />
      <SuccessCard
        title={"Status"}
        msg={alertMsg}
        open={successModal}
        onClose={modalCloseforAll}
      />
      {/* <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClosee}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClosee} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Profile;
